const page_schema = {
  "tiers": [
      {
          "name": "Targets",
          "type": "checkbox",
          "id": "targets",
          "class_name": "tags",
          "child_name": "target",
          "options": [
              {
                  "name": "RNA & cDNA",
                  "id": "rna-and-cdna"
              },
              {
                  "name": "RNA & DNA Oligo",
                  "id": "rna-and-dna-oligo"
              },
              {
                  "name": "ss-oligo Separation",
                  "id": "ss-oligo-separation"
              }
          ]
      },
      {
          "name": "Impurities",
          "type": "checkbox",
          "id": "impurities",
          "class_name": "tags",
          "child_name": "impuritie",
          "options": [
              {
                  "name": "PCR Inhibitors",
                  "id": "pcr-inhibitors"
              },
              {
                  "name": "Salts & Proteins",
                  "id": "salts-and-proteins"
              },
              {
                  "name": "Agarose/PAGE Gels",
                  "id": "agarose-page-gels"
              }
          ]
      },
      {
          "name": "Features",
          "type": "checkbox",
          "id": "features",
          "class_name": "tags",
          "child_name": "feature",
          "options": [
              {
                  "name": "High-Throughput",
                  "id": "high-throughput"
              },
              {
                  "name": "DNase I Included",
                  "id": "dnase-i-included"
              }
          ]
      },
      {
          "name": "Formats",
          "type": "checkbox",
          "id": "formats",
          "class_name": "tags",
          "child_name": "format",
          "options": [
              {
                  "name": "Columns",
                  "id": "columns"
              },
              {
                  "name": "96-Well Plate",
                  "id": "96-well-plate"
              },
              {
                  "name": "Magnetic Beads (Automatable)",
                  "id": "magnetic-beads-(automatable)"
              }
          ]
      }
  ],
  "filters": [],
  "products": {
      "RNA Clean & Concentrator-5": {
          "title": "RNA Clean & Concentrator-5",
          "catalogNumbers": "R1013, R1014, R1015, R1016",
          "description": "RNA clean up kits that provide a simple and reliable method for rapid preparation of high-quality, RT-PCR-ready, and DNA-free RNA (up to 10 µg). (Also applicable for DNA, namely cDNA and ssDNA.)",
          "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-5",
          "navigation_image": "rna_clean",
          "generalIndex": "998",
          "id": "rna-clean-concentrator-5",
          "tags": [
              "rna-and-cdna",
              "salts-and-proteins",
              "dnase-i-included",
              "columns"
          ],
          "filters": []
      },
      "RNA Clean & Concentrator-25": {
          "title": "RNA Clean & Concentrator-25",
          "catalogNumbers": "R1017, R1018",
          "description": "RNA clean up kits that provide a simple and reliable method for rapid preparation of high-quality, RT-PCR-ready RNA (up to 50 µg). (Also applicable for DNA, namely cDNA and ssDNA.)",
          "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-25",
          "navigation_image": "rna_clean",
          "generalIndex": "998",
          "id": "rna-clean-concentrator-25",
          "tags": [
              "rna-and-cdna",
              "salts-and-proteins",
              "columns"
          ],
          "filters": []
      },
      "RNA Clean & Concentrator-100": {
          "title": "RNA Clean & Concentrator-100",
          "catalogNumbers": "R1019",
          "description": "RNA clean up kit that provides a simple and reliable method for rapid preparation of high-quality, RT-PCR-ready RNA (up to 1 mg). (Also applicable for DNA, namely cDNA and ssDNA.)",
          "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-100",
          "navigation_image": "rna_clean",
          "generalIndex": "998",
          "id": "rna-clean-concentrator-100",
          "tags": [
              "rna-and-cdna",
              "salts-and-proteins",
              "columns"
          ],
          "filters": []
      },
      "RNA Clean & Concentrator-96": {
          "title": "RNA Clean & Concentrator-96",
          "catalogNumbers": "R1080",
          "description": "Simple and reliable high-throughput (96-well) preparation of high-quality RT-PCR-ready, DNA-free RNA. (Also applicable for DNA, namely cDNA and ssDNA.)",
          "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-96",
          "navigation_image": "high_throughput_96_well_rna_clean",
          "generalIndex": "998",
          "id": "rna-clean-concentrator-96",
          "tags": [
              "rna-and-cdna",
              "salts-and-proteins",
              "high-throughput",
              "96-well-plate"
          ],
          "filters": []
      },
      "RNA Clean & Concentrator MagBead": {
          "title": "RNA Clean & Concentrator MagBead",
          "catalogNumbers": "R1081, R1082",
          "description": "Simple and reliable high-throughput (magnetic bead-based) method for the rapid preparation of high-quality, DNA-free RNA. (Also applicable for DNA, namely cDNA and ssDNA.)",
          "handle": "/collections/rna-clean-concentrator-kits-rcc/products/rna-clean-concentrator-magbead",
          "navigation_image": "rna_clean_magbead",
          "generalIndex": "998",
          "id": "rna-clean-concentrator-magbead",
          "tags": [
              "rna-and-cdna",
              "salts-and-proteins",
              "high-throughput",
              "dnase-i-included",
              "magnetic-beads-(automatable)"
          ],
          "filters": []
      },
      "Oligo Clean & Concentrator": {
          "title": "Oligo Clean & Concentrator",
          "catalogNumbers": "D4060, D4061",
          "description": "Provides a streamlined method for efficient recovery and clean-up of DNA/RNA fragments and oligonucletides ≥ 16 nt from labeling (radioactive, biotin, DIG, etc.) and other enzymatic reactions.",
          "handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator",
          "navigation_image": "oligo_clean",
          "generalIndex": "998",
          "id": "oligo-clean-concentrator",
          "tags": [
              "rna-and-dna-oligo",
              "salts-and-proteins",
              "columns"
          ],
          "filters": []
      },
      "ZR-96 Oligo Clean & Concentrator": {
          "title": "ZR-96 Oligo Clean & Concentrator",
          "catalogNumbers": "D4062, D4063",
          "description": "Clean any DNA and RNA oligos in high-throughput format and elute in 10 &micro;l",
          "handle": "/collections/oligo-clean-concentrator-kits/products/oligo-clean-concentrator-zr96",
          "navigation_image": "high_throughput_96_well_oligo_clean",
          "generalIndex": "998",
          "id": "oligo-clean-concentrator-zr96",
          "tags": [
              "rna-and-dna-oligo",
              "salts-and-proteins",
              "high-throughput",
              "96-well-plate"
          ],
          "filters": []
      },
      "Zymoclean Gel RNA Recovery Kit": {
          "title": "Zymoclean Gel RNA Recovery Kit",
          "catalogNumbers": "R1011",
          "description": "The Zymoclean Gel RNA Recovery Kit provides a quick and efficient purification method for recovery of RNA fragments from agarose gels.",
          "handle": "/products/zymoclean-gel-rna-recovery-kit",
          "navigation_image": "agarose_gel",
          "generalIndex": "998",
          "id": "zymoclean-gel-rna-recovery-kit",
          "tags": [
              "rna-and-cdna",
              "rna-and-dna-oligo",
              "agarose-page-gels",
              "columns"
          ],
          "filters": []
      },
      "ZR small-RNA PAGE Recovery Kit": {
          "title": "ZR small-RNA PAGE Recovery Kit",
          "catalogNumbers": "R1070",
          "description": "The ZR small-RNA PAGE Recovery Kit provides an easy and efficient method for the extraction of high quality small RNAs from polyacrylamide gels (native and/or denatured)",
          "handle": "/products/zr-small-rna-page-recovery-kit",
          "navigation_image": "page_gel",
          "generalIndex": "998",
          "id": "zr-small-rna-page-recovery-kit",
          "tags": [
              "rna-and-cdna",
              "rna-and-dna-oligo",
              "agarose-page-gels",
              "columns"
          ],
          "filters": []
      },
      "ssDNA/RNA Clean & Concentrator": {
          "title": "ssDNA/RNA Clean & Concentrator",
          "catalogNumbers": "D7010, D7011",
          "description": "Separation of single-stranded nucleic acids from double-stranded nucleic acids.",
          "handle": "/products/ssdna-rna-clean-concentrator",
          "navigation_image": "ssdna_rna_clean",
          "generalIndex": "998",
          "id": "ssdna-rna-clean-concentrator",
          "tags": [
              "ss-oligo-separation",
              "columns"
          ],
          "filters": []
      },
      "OneStep PCR Inhibitor Removal Kit": {
          "title": "OneStep PCR Inhibitor Removal Kit",
          "catalogNumbers": "D6030, D6035. D6031",
          "description": "PCR inhibitor clean up kits that contain all the components needed for efficient removal of potent PCR inhibitors - all in one step. Free PCR inhibitor clean up kits sample with free shipping!",
          "handle": "/products/onestep-pcr-inhibitor-removal-kit",
          "navigation_image": "pcr_inhibitor",
          "generalIndex": "998",
          "id": "onestep-pcr-inhibitor-removal-kit",
          "tags": [
              "rna-and-cdna",
              "rna-and-dna-oligo",
              "pcr-inhibitors",
              "columns"
          ],
          "filters": []
      }
  }
}